// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","main":"_2whfmbVIPfUH","label":"_2obBl47yo3MX","primary":"_3MMgCfteNCqi","active":"_2YvyXpGExZ3U","secondary":"_6aWAr1KcV6ky"};